import * as React from 'react'
import {Suspense} from 'react'
import {Route} from 'react-router-dom'

import {LoadingPage} from '@pleo-io/telescope'

import {roleSets} from '~/shell/user'

import {SubscriptionExpenseDetailsLoader} from './components/subscription-expense-details-loader'

const SubscriptionExpenseDetails = React.lazy(
    async () => import('./screens/subscription-expense-details/subscription-expense-details'),
)
const SubscriptionExpensesList = React.lazy(
    async () => import('./screens/subscription-expenses-list/subscription-expenses-list'),
)
const SubscriptionsPage = React.lazy(
    async () => import('./screens/subscriptions/subscriptions-page-wrapper'),
)
const DedicatedCardDrawer = React.lazy(
    async () => import('~/feature-dedicated-cards/dedicated-card-drawer'),
)
const DedicatedCardDetailsDrawer = React.lazy(
    async () => import('~/feature-dedicated-cards/dedicated-card-details-drawer'),
)
const Wrapper = React.lazy(async () => import('./components/wrapper'))

export const SUBSCRIPTIONS_ROUTE = 'subscriptions'
export const DEDICATED_CARDS_ROUTE = 'dedicated-cards'
export const DEDICATED_CARD_DRAWER_ROUTE = 'create'
export const routes = (
    <Route element={<Wrapper />} handle={{auth: true, allowedRoles: roleSets.ownerAndBookkeeper}}>
        <Route path={DEDICATED_CARDS_ROUTE} element={<SubscriptionsPage />}>
            <Route
                path="create"
                element={
                    <Suspense fallback={<LoadingPage />}>
                        <DedicatedCardDrawer />
                    </Suspense>
                }
            />
            <Route
                path=":cardId"
                element={
                    <Suspense fallback={<LoadingPage />}>
                        <DedicatedCardDetailsDrawer />
                    </Suspense>
                }
            >
                <Route
                    path=":expenseId"
                    element={
                        <Suspense fallback={<LoadingPage />}>
                            <DedicatedCardDetailsDrawer />
                        </Suspense>
                    }
                />
            </Route>
        </Route>
        <Route path=":subscriptionId" element={<SubscriptionsPage />}>
            <Route
                path=":expenseId"
                element={
                    <Suspense fallback={<LoadingPage />}>
                        <SubscriptionExpenseDetails />
                    </Suspense>
                }
            />
            <Route
                index
                element={
                    <Suspense fallback={<SubscriptionExpenseDetailsLoader />}>
                        <SubscriptionExpensesList />
                    </Suspense>
                }
            />
        </Route>
        <Route index element={<SubscriptionsPage />} />
    </Route>
)
